import React, { Component } from 'react';
import { Form, Modal, message, Button, Table, Badge } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import { Entity } from '@comall-backend-builder/core/lib/parser';
const api = services.api;
/**
 * 置换skn
 */
class Bulkoperation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            columns: [
                {
                    title: '操作类型',
                    dataIndex: 'name',
                    key: 'skuCode',
                    align: 'center',
                    render: (_, record) => [<div>批量发货</div>],
                },
                {
                    title: '操作人',
                    dataIndex: 'userName',
                    key: 'userName',
                    align: 'center',
                },
                {
                    title: '操作时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    align: 'center',
                },
                {
                    title: '进度',
                    align: 'center',
                    render: (_, record) => [
                        <Button size="small" type="link">
                            {record.status == 'WAIT_EXECUTE' ? (
                                <Badge status="warning" text="处理中" />
                            ) : record.deliverStatus == 'ERROR' ? (
                                <Badge status="error" text="失败" />
                            ) : (
                                <Badge status="success" text="成功" />
                            )}
                        </Button>,
                    ],
                },
                {
                    title: '错误信息',
                    align: 'center',
                    render: (_, record) => [
                        <Button size="small" type="link">
                            {record.deliverStatus == 'ERROR' && record.status == 'EXECUTED' && (
                                <a target="_blank" href={`${record.downloadUrl}`}>
                                    下载
                                </a>
                            )}
                        </Button>,
                    ],
                },
            ],
            data: [],
        };
        this.handleCancel = this.handleCancel.bind(this);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
        const params = {
            page: 1,
            perPage: 10,
            type: 'BATCH_DELIVERY_ERROR',
        };
        api.get(params, { apiPath: `/exportQueQue` }).then((data) => {
            this.setState({
                data: data.result,
            });
        });
    };

    handleCancel = () => {
        // this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible } = this.state;
        return (
            <div>
                <Button onClick={this.showModal}>批量操作记录</Button>
                <Modal
                    visible={visible}
                    title="批量操作记录"
                    onCancel={this.handleCancel}
                    onOk={() => {
                        this.setState({
                            visible: false,
                        });
                    }}
                    okText={'关闭'}
                    width={900}
                >
                    <Table
                        pagination={{
                            defaultCurrent: 1,
                            defaultPageSize: 5,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20', '50'],
                        }}
                        columns={this.state.columns}
                        dataSource={this.state.data}
                    />
                </Modal>
            </div>
        );
    }
}
export default Form.create()(Bulkoperation);
